// @ts-nocheck
import { UAParser } from 'ua-parser-js'

export const isProd = import.meta.env.VITE_ENV === 'production'
export const isTest = import.meta.env.VITE_ENV === 'test'
export const isDev = import.meta.env.VITE_ENV === 'dev'
export const isBuild = import.meta.env.VITE_COMMAND === 'build'
export const isServe = import.meta.env.VITE_COMMAND === 'serve'

const parser = new UAParser(navigator.userAgent);
export const params = new URLSearchParams(location.search);

const ua = navigator.userAgent;
export const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
export const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
export const isWindows = !!ua.match(/Windows/i);
export const isMacOS = !!ua.match(/Macintosh/i);

export const isSupportPWA = 'serviceWorker' in navigator
export const isFullSupportPWA = 'serviceWorker' in navigator && 'PushManager' in window && 'BeforeInstallPromptEvent' in window && 'caches' in window
export const isProtocolHandlerSupported = 'registerProtocolHandler' in navigator || 'canOpenProtocolHandler' in navigator;

export const checkIfInPWA = () => {
  if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
    // 1 表示用户已接受安装(但可能安装失败) 2 已验证安装结果，确认已安装
    localStorage.setItem('pwaInstalled', '2')
    return true
  }
  return false
}

export const isInPWA = checkIfInPWA();

export const isPwaInstalled = isInPWA || localStorage.getItem('pwaInstalled') === '2';

// 检测是否为添加到iOS桌面应用
export const isFromIOSScreen = isIOS && window.navigator.standalone;

// 检测是否是facebook浏览器
export const isFacebookApp = /FBAV|FBAN|FBIOS|FB|FACEBOOK/i.test(parser.getBrowser().name);

// 检测是否是chrome浏览器
export const isChrome = /Chrome/i.test(parser.getBrowser().name);

// 检测是否在浏览器app中 // 不一定可靠
const isInBrowserApp = /chrome|safari|firefox|opera|edge/i.test(ua);

export const isWebView = /wv|WebView/i.test(navigator.userAgent);
export const hasAndroidBridge = typeof window.jsBridge !== 'undefined';

// 检测是否是在ios app且不在facebook浏览器且不在浏览器app中
export const isInIosApp = isIOS && (!!window.webkit && !!window.webkit.messageHandlers) && !isFacebookApp && !isInBrowserApp;

export const isInAndroidApp = isAndroid && (
  params.get('platform') == 'android' ||
  localStorage.platform == 'android' ||
	// android webview
  (isWebView && hasAndroidBridge) ||

	// 跟mike约好，打包app的ua中必须包含MobileUserAgent, 如 MobileUserAgent/1.0
	/\s+MobileUserAgent\/\d+/.test(ua)
)

export const isInApp = isInIosApp || isInAndroidApp

// 检测是否在浏览器
export const isInBrowser = !isInApp && !isInPWA && !isFromIOSScreen;

export const ch = params.get('ch') || localStorage.getItem('ch') || '';
if (ch) localStorage.setItem('ch', ch);

export const gp = params.get('gp') || localStorage.getItem('gp') || '';
if (gp) localStorage.setItem('gp', gp);

export const type = params.get('type') || localStorage.getItem('type') || '';
if (type) localStorage.setItem('type', type);

export const platform = params.get('pf') || localStorage.getItem('platform') || '';
if (platform) localStorage.setItem('platform', platform);

export const pixelId = params.get('pi') || localStorage.getItem('pixelId') || ''
if (pixelId) localStorage.setItem('pixelId', pixelId);

export const fromActivityId = params.get('ai');
export const referralCode = params.get('ic');
export const rewardId = params.get('ri');
export const currentDomain = params.get('cd');
export const preventionJump = params.get('pj');

export const activityType = params.get('activityType');

// export const language = params.get('language') || 'pt';
// export const themeStr = params.get('theme') || 'theme1';

function saveDeviceName() {
  let deviceName = localStorage.getItem('deviceName');
  if (!deviceName) {
    if (parser.getDevice().vendor) {
      deviceName = parser.getDevice().vendor + ' ' + parser.getDevice().model;
    } else {
      deviceName = parser.getOS().name;
    }

    localStorage.setItem('deviceName', deviceName);
  }
}

saveDeviceName();

export const deviceName = localStorage.getItem('deviceName');